import { env } from './env';

export const appSettings = {
  gtm: env.gtm,
  joinUrl: env.joinUrl,
};
